import { ctx } from '@/util/context'
import { queryParam } from '@/util/queryParams'

declare const __DEV__: boolean | undefined

const { errorHandler } = ctx('openModalFromQuery')

/**
 * Dev servers only: `?modal=<name>` opens that modal on boot, so a snap reaches it without a failure
 * path or a flaky trigger. The names are the keys of `devModals`.
 */
export function openModalFromQuery(): void {
    if (__DEV__ !== true) return
    const name = queryParam('modal')
    if (!name) return
    import('@/dev/devModals').then(({ devModals }) => devModals[name]?.()).catch(errorHandler)
}
